import React from 'react';
import {
	NiceFormFieldSet,
	InputWrapper,
	RangeInputWrapper,
	RangeWrapper,
} from './Components.styles';
import Slider from 'rc-slider';
import { ApInput } from '@alixpartners/ui-components';

const CheckboxInput = ({
	questionNo,
	legend,
	options,
	handleChange,
	formData,
	showPercentage,
}) => {
	return (
		<NiceFormFieldSet>
			<legend>{legend}</legend>
			{options.map(option => {
				let isChecked;
				let i;
				if (showPercentage) {
					isChecked = formData[option.name]?.some((item, index) => {
						if (item.hasOwnProperty([option.value])) {
							i = index;
						}
						return item.hasOwnProperty([option.value]);
					});
				} else {
					isChecked = formData[option.name]?.includes(option.value);
				}
				return (
					<div key={option.id} style={{ display: 'flex' }}>
						<div style={{ display: 'flex', alignItems: 'center' }}>
							<input
								type="checkbox"
								id={option.id}
								onChange={e => {
									if (showPercentage) {
										e.target.showPercentage = true;
									}
									handleChange(e);
								}}
								name={option.name}
								value={option.value}
								checked={isChecked}
							/>
							<label htmlFor={option.id}>{option.label}</label>
						</div>
						{showPercentage &&
							isChecked && (
								<RangeInputWrapper>
									<InputWrapper>
										<ApInput
											className="checkbox-input"
											symbol={'%'}
											value={formData[option.name][i]?.[option.value]}
											type="text"
											onChange={e => {
												let obj = {
													target: {
														value: e > 100 ? 100 : e,
														name: option.name,
														type: 'slider',
														isNumber: true,
														showPercentage: true,
														selectedOption: option.value,
													},
												};
												handleChange(obj);
											}}
										/>
									</InputWrapper>
									<RangeWrapper>
										<Slider
											className="checkbox-slider"
											min={0}
											max={100}
											defaultValue={0}
											value={formData[option.name][i]?.[option.value]}
											step={10}
											onChange={e => {
												let obj = {
													target: {
														value: e,
														name: option.name,
														type: 'slider',
														showPercentage: true,
														selectedOption: option.value,
													},
												};
												handleChange(obj);
											}}
										/>
									</RangeWrapper>
								</RangeInputWrapper>
							)}
					</div>
				);
			})}
		</NiceFormFieldSet>
	);
};

export default CheckboxInput;
